import { render, staticRenderFns } from "./SubjectItem.vue?vue&type=template&id=41a111f5&scoped=true"
import script from "./SubjectItem.vue?vue&type=script&lang=js"
export * from "./SubjectItem.vue?vue&type=script&lang=js"
import style0 from "./SubjectItem.vue?vue&type=style&index=0&id=41a111f5&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41a111f5",
  null
  
)

export default component.exports